import {httpGet} from './base'
import db from 'common/js/db'
// tab2 单个卡密查询
export const checkCard = (params) => { return httpGet('cardPkg/checkCard', params).then(res => res) }
// tab1 用户课程查询
export const checkPkg = (params) => { return httpGet('cardPkg/checkPkg', params).then(res => res) }
// others
export const checkPkgHistory = (userId, pkgId) => {
  // if (db.get(`${userId}-${pkgId}`)) {
  //   return new Promise((resolve, reject) => {
  //     resolve(db.get(`${userId}-${pkgId}`))
  //   })
  // }  为保证能查到实时数据，删除缓存代码
  return httpGet(`cardPkg/checkPkgHistory/${userId}/${pkgId}`).then(res => {
    db.set(`${userId}-${pkgId}`, res)
    return res
  })
}



// WEBPACK FOOTER //
// ./src/api/card-course-search.js